import {
  VALID_ACTION_ON_NULL_VALUES,
  DEFAULT_ACTION_ON_NULL,
  FIELDS_CONFIG,
} from '../constants/eligibilityEngine';

// Normalizes any stored actionOnNull value to one of VALID_ACTION_ON_NULL_VALUES.
// Handles legacy/lowercase values ('deny', 'ignore_rule') and unsupported
// legacy values ('move_to_pending') by falling back to DEFAULT_ACTION_ON_NULL.
export const normalizeActionOnNull = value => {
  if (!value) return DEFAULT_ACTION_ON_NULL;
  const upper = String(value).toUpperCase();
  const match = VALID_ACTION_ON_NULL_VALUES.find(
    v => upper === v || upper.startsWith(`${v}_`)
  );
  return match || DEFAULT_ACTION_ON_NULL;
};

// Rule config lookup keyed by the config `id` (which matches the server rule's
// `id`/`name`), mirroring the render-path lookup so the save path resolves the
// same adapter.
const FIELDS_CONFIG_BY_ID = FIELDS_CONFIG.reduce((acc, config) => {
  acc[config.id] = config;
  return acc;
}, {});

// Builds the API `parameters` object for a rule on save. The store holds a
// display-only value; when the rule declares `mapToApiFromStore`, it receives
// the whole rule so it can reach `catalog` (the original API value captured at
// load) or a catalog served outside the value (e.g. `allowedChannels`). Rules
// without it already store the API shape.
export const ruleToApiParameters = rule => {
  const config = FIELDS_CONFIG_BY_ID[rule.id] || FIELDS_CONFIG_BY_ID[rule.name];
  const apiValue = config && config.mapToApiFromStore
    ? config.mapToApiFromStore(rule)
    : rule.value;
  try {
    return typeof apiValue === 'string' ? JSON.parse(apiValue) : apiValue;
  } catch {
    return {};
  }
};
